import { ServerProduct } from '@/lib/janitsjar/Product';
import { InfoIcon } from '@fagmobler/ui';
import { useStores } from '@/components/store';

type Props = {
  product: ServerProduct;
};

export function ProductWarning({ product }: Props) {
  const { current: currentStoreQuery } = useStores();

  const currentStore = currentStoreQuery.data?.store;

  const currentStoreStock =
    product.stock?.find((s) => s.storeId === currentStore?.id) || null;

  if (!currentStoreStock?.reasonText) return null;

  return (
    <div className="w-full px-2 py-3 flex gap-2 items-center bg-neutral-30 border border-neutral-60 rounded-l">
      <InfoIcon className="w-5 h-5 text-neutral-70" />
      <span className="cap-sm font-bold">{currentStoreStock.reasonText}</span>
    </div>
  );
}
